/**
 * PluginRackToggle Component
 * Toggle for Plugin Rack panel
 */

import React from 'react';
import { Button } from '../../ui/button';
import { Layers } from 'lucide-react';

export const PluginRackToggle = ({
  showPluginRack,
  setShowPluginRack,
  isSimplifiedMode = false,
}) => {
  if (isSimplifiedMode) return null;
  
  return (
    <Button
      variant={showPluginRack ? 'default' : 'ghost'}
      size="sm"
      onClick={() => setShowPluginRack(!showPluginRack)}
      className={`relative p-2 ${showPluginRack ? 'bg-violet-500/20 text-violet-400 border border-violet-500/50' : 'text-zinc-400 hover:text-white hover:bg-violet-500/20'}`}
      data-testid="plugin-rack-btn"
      title="Plugin Rack - VST-style effects"
    >
      <Layers className="w-5 h-5" />
    </Button>
  );
};

export default PluginRackToggle;
